import { Fragment } from "react";
import { Box, Typography } from "@material-ui/core";
import Spinner from "./Spinner";

// Note : we cannot use theme in this component
// This is because InitializingScreen is called in AuthProvider, which is OUTSIDE of ThemeProvider. So theme does not exist here
// We hardcode dark color here (but in reality we dont know if the theme is dark or light)
const backgroundColor = "#222b36"
const fontFamily = "Helvetica"

const InitializingScreen = () => (
  // Rendering

  <Fragment>
    <Box
      sx={{
        alignItems: "center",
        backgroundColor,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "center",
        left: 0,
        p: 3,
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 2000,
      }}
    >
      <Box sx={{ mt: 3 }}>
        <Typography color="#ffffff" variant="h5" fontFamily={fontFamily}>
          Initializing...
        </Typography>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Spinner />
      </Box>
    </Box>
  </Fragment>
);

export default InitializingScreen;
